export * from "./pages";
export { default } from "./InvestmentMemo";
